import React from 'react';
import { Grid } from '@mui/material';
import MonthlyGraph from './MonthlyGraph';
import { AdminAnalyticsContext } from '../contexts/AdminAnalyticsContext';
import YearlyGraph from './YearlyGraph';

const SeedUnitsTotalCharts: React.FunctionComponent = () => {
  const {
    seedUnitsByMonthCharts,
    fetchSeedUnitsByMonthCharts,
    seedUnitsByMonthChartsLoading,
    seedUnitsByYearCharts,
    seedUnitsByYearChartsLoading,
    selectedYear,
    setSelectedYear,
    fetchSeedUnitsByYearCharts,
    showMonthly,
    setShowMonthly,
  } = React.useContext(AdminAnalyticsContext);

  React.useEffect(() => {
    fetchSeedUnitsByYearCharts();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <YearlyGraph
            title="Total Seed Units Per Year"
            labels={seedUnitsByYearCharts.years}
            values={seedUnitsByYearCharts.total_seed_units}
            loading={seedUnitsByYearChartsLoading}
            fetchFunction={(year) => {
              fetchSeedUnitsByMonthCharts(year);
              setShowMonthly(true);
            }}
            yearSetter={(year) => {
              setSelectedYear(year);
            }}
          />
        </Grid>
      </Grid>
      {showMonthly && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <br />
            <MonthlyGraph
              title="Total Seed Units Per Month"
              labels={seedUnitsByMonthCharts.month}
              values={seedUnitsByMonthCharts.total_seed_units}
              loading={seedUnitsByMonthChartsLoading}
              year={selectedYear}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SeedUnitsTotalCharts;
